<template>
    <IndexLayout leftWidth="200px">
        <template v-slot:menu>
            <Menu></Menu>
        </template>
    </IndexLayout>
</template>
<script>
import IndexLayout from "../components/IndexLayout.vue";
import Menu from "./components/Menu.vue";
export default {
    name: "index",
    components: { IndexLayout, Menu },
};
</script>
<style></style>
